
export class OutputRow {
    public id!: string
    public field!: string
    public command!: string
    public commandForDisplay!: string
    public jsonQueryStringCommand!: string
}